import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import mathUtil from '../../util/math';
import compose from '../../hoc/compose';
import NumericInput from '../numericInput/numericInput';
import { dataHooks } from './constants';
var VALUE_ORIGIN = {
  SLIDER: 'drag-slider',
  INPUT: 'text-input'
};
var AngleInput = /*#__PURE__*/function (_React$Component) {
  function AngleInput(props) {
    var _this;
    _classCallCheck(this, AngleInput);
    _this = _callSuper(this, AngleInput, [props]);
    _this.circleRefCallback = function (circle) {
      _this.circle = circle;
    };
    _this.saveCircleCenter = function () {
      var boundingRectangle = _this.circle.getBoundingClientRect();
      _this.circleCenter = {
        x: boundingRectangle.left + boundingRectangle.width / 2,
        y: boundingRectangle.top + boundingRectangle.height / 2
      };
    };
    _this.changeAngle = function (e) {
      return _this.props.onChange(mathUtil.getAngleFromOrigin(_this.circleCenter, {
        x: e.pageX,
        y: e.pageY
      }), VALUE_ORIGIN.SLIDER);
    };
    _this.onChange = function (value) {
      _this.props.onChange(value, VALUE_ORIGIN.INPUT);
    };
    _this.onClick = function (e) {
      e.preventDefault();
      _this.saveCircleCenter();
      _this.changeAngle(e);
    };
    _this.onKnobMouseDown = function (e) {
      _this.saveCircleCenter();
      window.document.addEventListener('mousemove', _this.changeAngle);
      window.document.addEventListener('mouseup', _this.onKnobMouseUp);
      if (_this.props.onSlideStart) {
        _this.props.onSlideStart(_this.props.value);
        _this.changeAngle(e);
      }
    };
    _this.onKnobMouseUp = function (e) {
      window.document.removeEventListener('mousemove', _this.changeAngle);
      window.document.removeEventListener('mouseup', _this.onKnobMouseUp);
      if (_this.props.onSlideEnd) {
        _this.props.onSlideEnd(_this.props.value);
        _this.changeAngle(e);
      }
    };
    _this.getCircleStyle = function () {
      return {
        transform: "rotate(".concat(_this.props.value, "deg)"),
        WebkitTransform: "rotate(".concat(_this.props.value, "deg)")
      };
    };
    _this.getKnobStyle = function () {
      return {
        transform: "rotate(-".concat(_this.props.value, "deg)"),
        WebkitTransform: "rotate(-".concat(_this.props.value, "deg)")
      };
    };
    return _this;
  }
  _inherits(AngleInput, _React$Component);
  return _createClass(AngleInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.removeEventListener('mousemove', this.changeAngle);
      window.document.removeEventListener('mouseup', this.onKnobMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-angle-input') + (this.props.disabled ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle",
        style: this.getCircleStyle(),
        ref: this.circleRefCallback,
        onDragStart: function onDragStart(e) {
          return e.preventDefault();
        },
        onClick: this.props.disabled ? null : this.onClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle-center"
      }), /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.knob,
        className: "knob",
        style: this.getKnobStyle(),
        onMouseDown: this.props.disabled ? null : this.onKnobMouseDown
      })), /*#__PURE__*/React.createElement(NumericInput, {
        dataHook: dataHooks.numericInput,
        disabled: this.props.disabled,
        value: this.props.value,
        onChange: this.onChange,
        onBlur: this.props.onBlur,
        unit: "angle",
        min: 0,
        max: 360,
        placeholder: "placeholder"
      }));
    }
  }]);
}(React.Component);
AngleInput.displayName = 'AngleInput';
AngleInput.propTypes = {
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The angle value */
  value: PropTypes.number.isRequired,
  /** A callback called with the new value every time the angle changes */
  onChange: PropTypes.func.isRequired,
  /** A callback called with the current value when starting to move the angle handle */
  onSlideStart: PropTypes.func,
  /** A callback called with the new value when releasing the angle handle */
  onSlideEnd: PropTypes.func,
  /** A callback function triggered when angleInput is blurred */
  onBlur: PropTypes.func,
  /** disables angle change */
  disabled: PropTypes.bool
};
AngleInput.defaultProps = {
  disabled: false
};
export default compose(AngleInput);